var _style, _rect, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMouseScroll = function SvgMouseScroll(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 48,
    viewBox: "0 0 30 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, "@keyframes scroll {\n      0% {cy: 12;}\n      30% {cy: 12;}\n      75% {cy: 33;}\n      100% {cy: 12;}\n    }\n    #dot {\n      animation: scroll 3s infinite;\n    }")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.19261,
    y: 1.88499,
    width: 25.6154,
    height: 42.6923,
    rx: 12.8077,
    stroke: "black",
    strokeWidth: 2.84615
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "dot",
    cx: 15.0005,
    cy: 11.8464,
    r: 2.84615,
    fill: "black"
  })));
};
export default SvgMouseScroll;